export function copy(a) {
  return JSON.parse(JSON.stringify(a));
}
